// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7aafd4e","scoped":false,"hasInlineConfig":false}!./src/shared/assets/css/orderBaseInfo.css
// module id = Wgkr
// module chunks = 0